import { render } from "./LineColumnSegPubPer.vue?vue&type=template&id=578d190a&scoped=true"
import script from "./LineColumnSegPubPer.vue?vue&type=script&lang=js"
export * from "./LineColumnSegPubPer.vue?vue&type=script&lang=js"

import "./LineColumnSegPubPer.vue?vue&type=style&index=0&id=578d190a&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578d190a"]])

export default __exports__